/**
 * Module dependencies.
 */

import { SubTitle } from 'app/components/atoms/sub-title/sub-title';
import { Field } from 'app/components/organisms/field/field';
import { formatCurrency } from 'app/core/utils/formatter';
import React, { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import { reduce } from 'lodash';
import { Text } from 'app/components/atoms/text/text';

/**
 * `Props` type.
 */

type Props = {
  data: any[] | undefined;
};

/**
 * Export `Payments` component.
 */

export function Payments({ data }: Props): JSX.Element {
  const { debt } = useMemo(() => {
    return reduce(
      data,
      (acc, item) => {
        if (new BigNumber(item.debt).isGreaterThan(0)) {
          acc.debt = acc.debt.plus(item.debt);
        }

        return {
          ...acc
        };
      },
      {
        debt: new BigNumber('0')
      }
    );
  }, [data]);

  return (
    <div className={'min-w-[300px] max-w-[300px] relative'}>
      <SubTitle className={'!text-[rgb(8,108,124)] font-bold border-b-2 border-[#ccc] pb-2 mb-2 w-full block'}>
        {'Pagamentos'}
      </SubTitle>

      <Text className={'text-xs pb-6 block'}>
        {'Informação de propostas abertas e fechadas. Abertas indica o valor de budget que ainda não tem proposta.'}
      </Text>

      <Field
        info={'Soma de todos os valores em divida após finalização de trabalhos da área.'}
        title={'A Decorrer'}
        value={formatCurrency(new BigNumber(debt).toFixed(2))}
      />
    </div>
  );
}
